import React, { useState } from 'react';
import { Grid, Row, Col } from '@zendeskgarden/react-grid';
import InspectionMetrics from 'routes/Products/ListingV2/components/InspectionMetrics/InspectionMetrics';
import { PropTypes } from 'prop-types';
import { SM } from '@zendeskgarden/react-typography';
import { split } from 'lodash';
import InPageOverlay from 'components/InPageOverlay/InPageOverlay';
import { PipeFactsSectionHeaders, InfoTab } from '../ProductsPipeFacts.styles';
import ProductsNominalDetails from '../../ProductsNominalDetails/ProductsNominalDetails';
import ProductsAlloyDetails from '../../ProductsAlloyDetails/ProductsAlloyDetails';
import ProductsEndFinishDetails from '../../ProductsEndFinishDetails/ProductsEndFinishDetails';
import { productNominalDetailsShape } from '../../../../../propTypesObjects';
import PipeFactsInspectionTracker from '../../PipeFactsInspectionTracker/PipeFactsInspectionTracker';
import InspectionScopesOverlay from '../../InspectionScopesOverlay/InspectionScopesOverlay';

export function QualityInfoTab({
  productDetails,
  listingsRefactor,
  onInquire,
}) {
  const whatIsVal = split(productDetails?.quality_information?.header, ' ')[0];
  const [inPageOverlayViewOpen, setInPageOverlay] = useState(false);

  return (
    <InfoTab>
      <Grid>
        <Row className="qualityInfo">
          <Col
            lg={3}
            style={{
              marginBottom: '20px',
              display: 'flex',
              justifyContent: 'center',
            }}
            className="qualityTracker"
          >
            <PipeFactsInspectionTracker productDetails={productDetails} />
          </Col>
          <Col className="qualityDetails">
            <PipeFactsSectionHeaders>
              {productDetails?.quality_information?.header ||
                `Inspection Not Started`}
            </PipeFactsSectionHeaders>
            <p style={{ padding: '10px 0' }} className="pipeFactsDescription">
              {productDetails?.quality_information?.description ||
                `Material that has not started our inspection process is either awaiting a field inspection at it's point of origin, or in transit to one of our partner facilities where it will undergo a receiving inspection.`}
            </p>
            <PipeFactsSectionHeaders>
              What is PipeFacts?
            </PipeFactsSectionHeaders>
            <div className="pipeFactsDescription">
              <p>
                PipeFacts™ is a proprietary inspection process that measures up
                to 220+ data points through a combination of field assessments,
                formal inspections, and office technical review. We utilize API
                5CRA as our baseline analysis criteria and have included other
                industry best practices to guide our comprehensive quality
                service, PipeFacts™. As a result of our quality data collection,
                we provide buyers with a comprehensive Executive Summary to
                equip you with all of the information needed to put this
                material into critical application.
              </p>
            </div>
          </Col>
          <Col style={{ marginBottom: '10px' }} className="qualityScope">
            <Row id="inspectionMetricsHeader">
              <PipeFactsSectionHeaders style={{ justifyContent: 'center' }}>
                {whatIsVal
                  ? `What is ${whatIsVal} Inspection Scope?`
                  : `Inspections have not started`}
              </PipeFactsSectionHeaders>
              {whatIsVal !== 'Our' && (
                <SM
                  as="span"
                  className="learnMoreLink"
                  semibold
                  blue
                  link
                  onClick={() => setInPageOverlay(true)}
                >
                  Learn More
                </SM>
              )}
            </Row>
            <Row id="inspectionMetricsRow">
              <InspectionMetrics
                productDetails={productDetails}
                listingsRefactor={listingsRefactor}
                onInquire={onInquire}
              />
            </Row>
          </Col>
        </Row>
        <InPageOverlay
          showClose
          onClose={() => setInPageOverlay(false)}
          open={inPageOverlayViewOpen}
          innerStyle={{
            height: '100%',
            maxHeight: '850px',
          }}
          disableScroll
        >
          <div style={{ padding: '30px', overflow: 'auto' }}>
            <InspectionScopesOverlay />
          </div>
        </InPageOverlay>
      </Grid>
    </InfoTab>
  );
}

QualityInfoTab.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
  onInquire: PropTypes.func,
};

export function SizeStrengthTab({ productDetails, listingsRefactor }) {
  return (
    <InfoTab tab="sizeAndStrength">
      <ProductsNominalDetails
        productDetails={productDetails}
        listingsRefactor={listingsRefactor}
      />
    </InfoTab>
  );
}

SizeStrengthTab.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};

export function AlloyDetailsTab({ productDetails, listingsRefactor }) {
  return (
    <InfoTab
      backgroundImage={`url('/images/periodicTable.svg')`}
      backgroundSize="50%"
      backgroundPosition="right center"
    >
      <ProductsAlloyDetails
        productDetails={productDetails}
        listingsRefactor={listingsRefactor}
      />
    </InfoTab>
  );
}

AlloyDetailsTab.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};

export function ConnectionDetails({ productDetails, listingsRefactor }) {
  return (
    <InfoTab
      className="connectionDetailsTab"
      backgroundImage={`url('/images/stackedPipes.svg')`}
      backgroundSize="53% 180%"
      backgroundPosition="right center"
    >
      <ProductsEndFinishDetails
        productDetails={productDetails}
        listingsRefactor={listingsRefactor}
      />
    </InfoTab>
  );
}

ConnectionDetails.propTypes = {
  productDetails: productNominalDetailsShape,
  listingsRefactor: PropTypes.bool,
};
